import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { push } from 'react-router-redux'
import axios from 'axios'

// Styles
import styles from './styles'

// Material UI
import { withStyles } from 'material-ui/styles'
import Typography from 'material-ui/Typography'
import Card, { CardActions, CardContent, CardMedia } from 'material-ui/Card'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'

class Outbound extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      data: [],
      empty: false
    }
  }
  render() {
    const { classes, theme, location, data } = this.props

    var pathArray = window.location.pathname.split('/')
    var id = pathArray[pathArray.length - 1]

    let currentComponent = this
    if (id.length > 2 && this.props.customer_number) {
      axios
        .get(
          `https://api.dsnapis.com/customer/${
            this.props.customer_number
          }/pw/teSt1/candidate/${id}/commtypeALL/2/db/2/read`
        )
        .then(function(response) {
          if (response.data.length == 0) {
            currentComponent.setState({
              loaded: true,
              data: response.data,
              empty: true
            })
          } else {
            currentComponent.setState({
              loaded: true,
              data: response.data,
              empty: false
            })
          }
        })
    } else {
      alert('The Candidate ID you entered is invalid.')
      this.props.changeRoute('/console/search/search_by_name')
    }

    //alert(this.props.customer_number)
    //console.log(JSON.stringify(data));

    return (
      <div>
        <Card className={classes.root}>
          <Typography> All Outbound Messages </Typography>
        </Card>
        <br />
        <Card className={classes.root}>
          {this.state.data.map(function(text, index) {
            return (
              <Typography className={classes.text}> {text.message} </Typography>
            )
          })}

          {!this.state.loaded && <Typography> Loading... </Typography>}
          {this.state.empty && <Typography> No Messages </Typography>}
        </Card>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    customer_number: state.customer.number,
    project_id: state.prefix.project_id
  }
}

const mapDispatchToProps = dispatch => {
  return {
    dispatch,
    changeRoute: url => dispatch(push(url))
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(mapStateToProps, mapDispatchToProps)(Outbound)
  )
)



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/scenes/AllCommunication/scenes/outbound/index.js